import createLucideIcon from '../createLucideIcon';

const BluetoothConnected = createLucideIcon('BluetoothConnectedIcon', [
  ['path', { d: 'm7 7 10 10-5 5V2l5 5L7 17', key: '1q5490' }],
  ['line', { x1: '18', y1: '12', y2: '12', x2: '21', key: '17rheb' }],
  ['line', { x1: '3', y1: '12', y2: '12', x2: '6', key: '1l5nc6' }],
]);

export default BluetoothConnected;
